package fyi.moko.hotpl.ui.home

import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectVerticalDragGestures
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onSizeChanged
import fyi.moko.hotpl.data.location.CurrentLocationProvider
import fyi.moko.hotpl.domain.model.OTHER_BUCKET
import fyi.moko.hotpl.ui.isIosPlatform
import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExtendedFloatingActionButton
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.List
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material.icons.filled.FavoriteBorder
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material.icons.filled.LocationOn
import androidx.compose.material.icons.filled.MoreVert
import androidx.compose.material.icons.filled.Place
import androidx.compose.material.icons.filled.Search
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SwipeToDismissBox
import androidx.compose.material3.SwipeToDismissBoxValue
import androidx.compose.material3.Tab
import androidx.compose.material3.TabRow
import androidx.compose.material3.TabRowDefaults
import androidx.compose.material3.TabRowDefaults.tabIndicatorOffset
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.rememberSwipeToDismissBoxState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.selected
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import fyi.moko.hotpl.data.backup.BackupImportPreview
import fyi.moko.hotpl.domain.model.Emotion
import fyi.moko.hotpl.domain.model.Place
import fyi.moko.hotpl.domain.model.PlaceCategory
import fyi.moko.hotpl.domain.model.PlaceStatus
import fyi.moko.hotpl.domain.model.PlaceVisitSummary
import fyi.moko.hotpl.domain.model.RechargeCandidate
import fyi.moko.hotpl.domain.model.displayLabel
import fyi.moko.hotpl.domain.service.NoOpUsageTracker
import fyi.moko.hotpl.ui.friends.mutualWishNames
import fyi.moko.hotpl.domain.service.UsageEvents
import fyi.moko.hotpl.domain.service.UsageTracker
import fyi.moko.hotpl.ui.directory.DirectoryScreen
import fyi.moko.hotpl.ui.friends.FriendsGateViewModel
import fyi.moko.hotpl.ui.friends.FriendsLockedPanel
import fyi.moko.hotpl.ui.changelog.ChangelogViewModel
import fyi.moko.hotpl.ui.friends.FriendsScreen
import fyi.moko.hotpl.ui.map.PlacePinIcon
import fyi.moko.hotpl.ui.map.PlacesMap
import fyi.moko.hotpl.ui.map.wantToGoPlaceIds
import fyi.moko.hotpl.ui.theme.dotColor
import fyi.moko.hotpl.ui.util.RecallCandidate
import fyi.moko.hotpl.ui.util.lastVisitPhrase
import fyi.moko.hotpl.ui.util.visitGlowFraction
import androidx.compose.ui.graphics.lerp
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.Shape
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/** Plays the search-toggle discovery pulse only once per app launch (process-wide). */
private var searchHintPlayed = false

enum class HomeTab {
    JOURNAL,
    DIRECTORY,
    FRIENDS,
}

/** Per-tab app-bar subtitle (appbar design doc, 2026-07-19: dynamic over a fixed caption). */
private fun homeTabSubtitle(tab: HomeTab): String = when (tab) {
    HomeTab.JOURNAL -> "Saved places"
    HomeTab.DIRECTORY -> "Discover"
    HomeTab.FRIENDS -> "Friends"
}

/**
 * "Premium prep" placeholder for the Directory tab (HOTPL_MASTER backlog A-6) — no real
 * entitlement check exists yet, so this is visual only and never blocks the tab.
 */
@Composable
private fun PremiumSoonBadge(modifier: Modifier = Modifier) {
    Text(
        text = "Soon",
        style = MaterialTheme.typography.labelSmall,
        color = MaterialTheme.colorScheme.primary,
        maxLines = 1,
        softWrap = false,
        modifier = modifier
            .clip(RoundedCornerShape(percent = 50))
            .background(MaterialTheme.colorScheme.primary.copy(alpha = 0.12f))
            .padding(horizontal = 6.dp, vertical = 1.dp),
    )
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun HomeScreen(
    onAddPlace: () -> Unit,
    onPlaceClick: (String) -> Unit,
    onOpenAccount: () -> Unit = {},
    onOpenChangelog: () -> Unit = {},
) {
    val viewModel: HomeViewModel = koinViewModel()
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    // Bound to the TextField's value directly (not state.query) — see HomeViewModel.queryText.
    val queryText by viewModel.queryText.collectAsStateWithLifecycle()
    // 화면 로컬 상태가 아니라 기기에 기억되는 값이다 — 콜드 스타트마다 목록으로 돌아오던
    // 것을 리뷰어가 매번 다시 눌렀다(R-7). 기본값은 그대로 목록이고, 한 번 지도로 두면
    // 다음에도 지도로 열린다.
    val showMap by viewModel.mapFirst.collectAsStateWithLifecycle()
    val emotionLabels by viewModel.emotionLabels.collectAsStateWithLifecycle()
    val friendWishNames by viewModel.friendWishNames.collectAsStateWithLifecycle()
    var selectedTab by rememberSaveable { mutableStateOf(HomeTab.JOURNAL) }
    val scope = rememberCoroutineScope()
    val snackbarHostState = remember { SnackbarHostState() }
    val showMessage: (String) -> Unit = { msg -> scope.launch { snackbarHostState.showSnackbar(msg) } }
    val locationProvider = koinInject<CurrentLocationProvider>()
    val usageTracker = koinInject<UsageTracker>()
    val restorePreview = viewModel.restorePreview

    // Usage log (0-39): which Home tab is on screen, and the R-14 signal — a list that went
    // empty under active filters/search. Keyed on the boolean so a still-empty list doesn't
    // re-report on every unrelated recomposition.
    LaunchedEffect(selectedTab) {
        usageTracker.track(UsageEvents.SCREEN, mapOf("name" to "home/${selectedTab.name.lowercase()}"))
    }
    val emptyUnderFilters = !state.loading && state.totalCount > 0 && state.places.isEmpty() && state.isFiltering
    LaunchedEffect(emptyUnderFilters) {
        if (emptyUnderFilters) {
            usageTracker.track(
                UsageEvents.EMPTY_RESULTS,
                mapOf(
                    "query_len" to state.query.length.toString(),
                    "tags" to state.selectedTags.size.toString(),
                    "categories" to state.selectedCategories.size.toString(),
                    "visit" to state.visitFilter.name.lowercase(),
                    "liked" to state.likedFilter.toString(),
                ),
            )
        }
    }

    // Friends tab gate: anonymous sessions see a locked panel instead of FriendsScreen
    // (see FriendsGateViewModel doc). linkWithGoogle/linkWithApple preserve the uid, so
    // there's no currentUserId emission to react to on link — re-checking here re-runs
    // every time this composable re-enters composition (e.g. navigating back from
    // Account), which is the "re-check on Home resume" the design doc settled on.
    // Alpha builds go to reviewers, who need to know what to look at before they look.
    val changelogViewModel: ChangelogViewModel = koinViewModel()
    val hasUnseenChangelog by changelogViewModel.hasUnseen.collectAsStateWithLifecycle()

    val friendsGateViewModel: FriendsGateViewModel = koinViewModel()
    val friendsIsAnonymous by friendsGateViewModel.isAnonymous.collectAsStateWithLifecycle()
    LaunchedEffect(Unit) { friendsGateViewModel.refresh() }

    LaunchedEffect(viewModel.uiEvents) {
        viewModel.uiEvents.collect { event ->
            when (event) {
                is HomeUiEvent.ShowMessage -> showMessage(event.message)
            }
        }
    }
    val permissionRequester = rememberLocationPermissionRequest { granted ->
        if (!granted) {
            viewModel.clearNearestSort()
            showMessage("Location permission is needed for nearest sorting")
        } else {
            scope.launch {
                val location = locationProvider.lastKnownLocation()
                if (location == null) {
                    viewModel.clearNearestSort()
                    showMessage("Current location unavailable")
                } else {
                    viewModel.selectNearestSort(location)
                }
            }
        }
    }

    val backupPicker = rememberBackupFilePicker()

    HomeScreenContent(
        state = state,
        queryText = queryText,
        selectedTab = selectedTab,
        onSelectTab = { selectedTab = it },
        friendsIsAnonymous = friendsIsAnonymous,
        showMap = showMap,
        snackbarHostState = snackbarHostState,
        onToggleShowMap = { viewModel.setMapFirst(!showMap) },
        onAddPlace = onAddPlace,
        onOpenAccount = onOpenAccount,
        onOpenChangelog = onOpenChangelog,
        hasUnseenChangelog = hasUnseenChangelog,
        usageTracker = usageTracker,
        onPlaceClick = { id ->
            viewModel.selectPlace(id)
            onPlaceClick(id)
        },
        onSelectPlace = viewModel::selectPlace,
        onDeletePlace = viewModel::deletePlace,
        onLoadSample = viewModel::loadSampleData,
        onSelectMostRecentlyVisitedSort = viewModel::selectMostRecentlyVisitedSort,
        onSelectNearestSort = {
            if (state.sortMode == HomeSortMode.NEAREST) {
                viewModel.clearNearestSort()
            } else if (!locationProvider.isPermissionGranted()) {
                permissionRequester.launch()
            } else {
                scope.launch {
                    val location = locationProvider.lastKnownLocation()
                    if (location == null) {
                        viewModel.clearNearestSort()
                        showMessage("Current location unavailable")
                    } else {
                        viewModel.selectNearestSort(location)
                    }
                }
            }
        },
        onSelectNameSort = viewModel::selectNameSort,
        onQueryChange = viewModel::onQueryChange,
        onClearFilters = viewModel::clearFilters,
        onToggleTag = viewModel::toggleTag,
        onToggleCategory = viewModel::toggleCategory,
        onToggleLikedFilter = viewModel::toggleLikedFilter,
        onToggleVisitFilter = viewModel::toggleVisitFilter,
        onToggleRechargeEmotion = viewModel::toggleRechargeEmotion,
        emotionLabels = emotionLabels,
        friendWishNames = friendWishNames,
        onMergeDuplicatesRequest = viewModel::mergeDuplicatePlaces,
        onExportBackupRequest = {
            backupPicker.exportJson(
                suggestedFileName = defaultBackupFileName(),
                produceJson = { viewModel.exportBackupJson() },
                onResult = { result ->
                    when (result) {
                        BackupExportResult.Success -> showMessage("Backup exported")
                        BackupExportResult.Cancelled -> Unit // user dismissed — stay quiet
                        is BackupExportResult.Failed -> showMessage("Backup export failed")
                    }
                },
            )
        },
        onRestoreBackupRequest = {
            backupPicker.importJson { result ->
                when (result) {
                    is BackupImportResult.Success -> scope.launch {
                        viewModel.prepareRestore(result.content)
                    }
                    BackupImportResult.Cancelled -> Unit // user dismissed — stay quiet
                    is BackupImportResult.Failed -> showMessage("Backup import failed")
                }
            }
        },
        restorePreview = restorePreview,
        onDismissRestorePreview = viewModel::dismissRestorePreview,
        onConfirmRestore = viewModel::confirmRestore,
        onDismissEmptyAccountHint = viewModel::dismissEmptyAccountHint,
    )

    val activeError = viewModel.activeBackupError
    if (activeError != null) {
        AlertDialog(
            onDismissRequest = viewModel::dismissBackupError,
            title = { Text("Backup Operation Failed") },
            text = { Text(activeError.message) },
            confirmButton = {
                TextButton(onClick = { viewModel.retryBackupAction(activeError.actionType) }) {
                    Text("Retry")
                }
            },
            dismissButton = {
                TextButton(onClick = viewModel::dismissBackupError) {
                    Text("Cancel")
                }
            }
        )
    }

    if (state.isBackupLoading) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.Black.copy(alpha = 0.5f)),
            contentAlignment = Alignment.Center
        ) {
            CircularProgressIndicator()
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun HomeScreenContent(
    state: HomeUiState,
    // Kept separate from state.query — see HomeViewModel.queryText for why the search
    // TextField must not bind to the combine()-derived uiState value.
    queryText: String = state.query,
    selectedTab: HomeTab = HomeTab.JOURNAL,
    onSelectTab: (HomeTab) -> Unit = {},
    friendsIsAnonymous: Boolean = false,
    showMap: Boolean,
    onToggleShowMap: () -> Unit,
    onAddPlace: () -> Unit,
    onPlaceClick: (String) -> Unit,
    /** Highlights a place without leaving the screen — the map's first marker tap. */
    onSelectPlace: (String) -> Unit = {},
    onOpenAccount: () -> Unit = {},
    onOpenChangelog: () -> Unit = {},
    /** Keeps the "what's new" cue on screen until the changelog is actually opened. */
    hasUnseenChangelog: Boolean = false,
    /** Usage log (0-39) for the taps that never reach the ViewModel — menu, cues, search toggle. */
    usageTracker: UsageTracker = NoOpUsageTracker,
    onDeletePlace: (String) -> Unit = {},
    onLoadSample: () -> Unit = {},
    onSelectMostRecentlyVisitedSort: () -> Unit,
    onSelectNearestSort: () -> Unit,
    onSelectNameSort: () -> Unit = {},
    onQueryChange: (String) -> Unit,
    onClearFilters: () -> Unit,
    onToggleTag: (String) -> Unit,
    onToggleCategory: (PlaceCategory) -> Unit = {},
    onToggleLikedFilter: () -> Unit = {},
    onToggleVisitFilter: (HomeVisitFilter) -> Unit = {},
    onToggleRechargeEmotion: (Emotion) -> Unit = {},
    emotionLabels: Map<String, String> = emptyMap(),
    /** placeId → friends who also want to go (0-37 stage 2); empty offline. */
    friendWishNames: Map<String, List<String>> = emptyMap(),
    snackbarHostState: SnackbarHostState = SnackbarHostState(),
    onMergeDuplicatesRequest: () -> Unit = {},
    onExportBackupRequest: () -> Unit = {},
    onRestoreBackupRequest: () -> Unit = {},
    restorePreview: BackupImportPreview? = null,
    onDismissRestorePreview: () -> Unit = {},
    onConfirmRestore: () -> Unit = {},
    onDismissEmptyAccountHint: () -> Unit = {},
    mapContent: @Composable (List<Place>, String?, (String) -> Unit, (String) -> Unit, Modifier) -> Unit =
        { places, selectedPlaceId, handlePlaceSelect, handlePlaceOpen, modifier ->
            PlacesMap(
                places = places,
                selectedPlaceId = selectedPlaceId,
                onPlaceSelect = handlePlaceSelect,
                onPlaceOpen = handlePlaceOpen,
                modifier = modifier,
                // 핀 색은 한 가지다(2026-09-17 사용자 결정, R-8 되돌림 — PlacePinColor.kt 참고).
                // pinColors를 비워 두면 세 플랫폼 모두 NEUTRAL_PIN_COLOR로 그린다.
                wantToGoIds = wantToGoPlaceIds(state.places, state.visitSummaries),
            )
        },
) {
    var showBackupMenu by rememberSaveable { mutableStateOf(false) }
    // The search/sort/tag panel is collapsed by default so the list owns the first screen
    // (especially on iPhone); a top-bar search toggle reveals it. See UX_IMPROVEMENT_PLAN.
    var showSearch by rememberSaveable { mutableStateOf(false) }
    val hasContent = !state.loading && state.totalCount > 0
    val trackMenuTap: (String) -> Unit = { item ->
        usageTracker.track(UsageEvents.MENU_TAP, mapOf("item" to item))
    }
    val scope = rememberCoroutineScope()
    // Hoisted so the app-bar title tap (below) can scroll the Journal list back to top —
    // Instagram-style logo tap, scoped to the tab that actually has a scrollable list.
    val journalListState = rememberLazyListState()
    val fabExpanded by remember(showMap) {
        derivedStateOf { showMap || journalListState.firstVisibleItemIndex == 0 }
    }

    // One-shot attention pulse on the search toggle the first time the populated home
    // screen appears, hinting that search/sort/tags live behind it. Once per app launch.
    val searchHintScale = remember { Animatable(1f) }
    LaunchedEffect(hasContent) {
        if (hasContent && !showSearch && !searchHintPlayed) {
            searchHintPlayed = true
            delay(600)
            repeat(2) {
                searchHintScale.animateTo(1.35f, tween(durationMillis = 220))
                searchHintScale.animateTo(1f, tween(durationMillis = 220))
            }
        }
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            TopAppBar(
                // SemiBold isn't in the M3 default type scale, so it's overridden inline
                // rather than via a custom Typography (see appbar design doc, 2026-07-19).
                // Title tap: Instagram-style "back to top" — switches to Journal when on
                // another tab, otherwise scrolls the Journal list to top.
                title = {
                    Column(
                        modifier = Modifier
                            .clickable(
                                onClickLabel = "Scroll to top",
                                onClick = {
                                    if (selectedTab != HomeTab.JOURNAL) {
                                        onSelectTab(HomeTab.JOURNAL)
                                    } else if (!showMap) {
                                        scope.launch { journalListState.animateScrollToItem(0) }
                                    }
                                },
                            )
                            .testTag("home-title"),
                    ) {
                        Text("HOTPLA", fontWeight = FontWeight.SemiBold)
                        Text(
                            text = homeTabSubtitle(selectedTab),
                            style = MaterialTheme.typography.labelSmall,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                    }
                },
                actions = {
                    if (hasContent) {
                        IconButton(
                            onClick = {
                                showSearch = !showSearch
                                usageTracker.track(UsageEvents.SEARCH_TOGGLE, mapOf("open" to showSearch.toString()))
                            },
                            modifier = Modifier.testTag("home-search-toggle"),
                        ) {
                            Icon(
                                Icons.Default.Search,
                                contentDescription = if (showSearch) "Hide search" else "Search",
                                modifier = Modifier.scale(searchHintScale.value),
                            )
                        }
                    }
                    if (selectedTab == HomeTab.JOURNAL) {
                        // Icon toggle (was a "List"/"Map" TextButton) so it reads consistently
                        // with the search icon beside it; the state itself is carried by the
                        // icon shown next (contentDescription mirrors it for a11y).
                        IconButton(
                            onClick = onToggleShowMap,
                            modifier = Modifier.testTag("home-toggle-map"),
                        ) {
                            Icon(
                                if (showMap) Icons.AutoMirrored.Filled.List else Icons.Default.LocationOn,
                                contentDescription = if (showMap) "Show list" else "Show map",
                            )
                        }
                    }
                    // iOS: primary "add" lives as a nav-bar + (top right) per HIG;
                    // Android keeps the Material FAB (see floatingActionButton).
                    if (isIosPlatform && selectedTab == HomeTab.JOURNAL) {
                        IconButton(
                            onClick = {
                                usageTracker.track(UsageEvents.ADD_PLACE_TAP, mapOf("from" to "nav_bar"))
                                onAddPlace()
                            },
                            modifier = Modifier.testTag("home-add-place"),
                        ) {
                            Icon(Icons.Default.Add, contentDescription = "Add place")
                        }
                    }
                    Box {
                        IconButton(onClick = { showBackupMenu = true }) {
                            BadgedBox(
                                badge = {
                                    if (hasUnseenChangelog) Badge(modifier = Modifier.testTag("changelog-badge"))
                                },
                            ) {
                                Icon(Icons.Default.MoreVert, contentDescription = "More options")
                            }
                        }
                        // Android: Material dropdown anchored to the icon. iOS uses an
                        // action sheet (ModalBottomSheet) rendered below — see backupSheet.
                        if (!isIosPlatform) {
                            DropdownMenu(
                                expanded = showBackupMenu,
                                onDismissRequest = { showBackupMenu = false },
                            ) {
                                DropdownMenuItem(
                                    text = { Text(if (hasUnseenChangelog) "What's new •" else "What's new") },
                                    onClick = {
                                        showBackupMenu = false
                                        trackMenuTap("changelog")
                                        onOpenChangelog()
                                    },
                                    modifier = Modifier.testTag("menu-changelog"),
                                )
                                DropdownMenuItem(
                                    text = { Text("Export backup") },
                                    onClick = {
                                        showBackupMenu = false
                                        trackMenuTap("export_backup")
                                        onExportBackupRequest()
                                    },
                                )
                                DropdownMenuItem(
                                    text = { Text("Restore backup") },
                                    onClick = {
                                        showBackupMenu = false
                                        trackMenuTap("restore_backup")
                                        onRestoreBackupRequest()
                                    },
                                )
                                DropdownMenuItem(
                                    text = { Text("Merge duplicate places") },
                                    onClick = {
                                        showBackupMenu = false
                                        trackMenuTap("merge_duplicates")
                                        onMergeDuplicatesRequest()
                                    },
                                )
                                DropdownMenuItem(
                                    text = { Text("Account") },
                                    onClick = {
                                        showBackupMenu = false
                                        trackMenuTap("account")
                                        onOpenAccount()
                                    },
                                )
                            }
                        }
                    }
                },
            )
        },
        floatingActionButton = {
            if (!isIosPlatform && selectedTab == HomeTab.JOURNAL) {
                // Collapses to icon-only once the Journal list is scrolled past the top —
                // M3's official expanded/collapsed FAB pattern, safer than a fixed size
                // shrink (which would cross the 48dp touch-target minimum).
                ExtendedFloatingActionButton(
                    onClick = {
                        usageTracker.track(UsageEvents.ADD_PLACE_TAP, mapOf("from" to "fab"))
                        onAddPlace()
                    },
                    expanded = fabExpanded,
                    modifier = Modifier.semantics {
                        contentDescription = "Add place"
                    },
                    icon = { Icon(Icons.Default.Add, contentDescription = null) },
                    text = { Text("Add place") },
                )
            }
        },
    ) { innerPadding ->
        val contentModifier = Modifier.fillMaxSize().padding(innerPadding)
        Column(contentModifier) {
            // Main tab switcher: Journal (existing), Directory (Yellow Pages), Friends (Social).
            // 44dp trims the default 48dp strip while staying at the 44dp/pt touch minimum;
            // the 3dp indicator keeps the selected tab legible at the reduced height.
            TabRow(
                selectedTabIndex = selectedTab.ordinal,
                indicator = { tabPositions ->
                    TabRowDefaults.SecondaryIndicator(
                        modifier = Modifier.tabIndicatorOffset(tabPositions[selectedTab.ordinal]),
                        height = 3.dp,
                    )
                },
            ) {
                Tab(
                    selected = selectedTab == HomeTab.JOURNAL,
                    onClick = { onSelectTab(HomeTab.JOURNAL) },
                    modifier = Modifier.height(44.dp),
                    text = { Text("Journal") },
                )
                // 이 탭만 `text` 슬롯을 안 쓰고 콘텐츠 슬롯을 직접 쓴다. `text` 슬롯은 좌우
                // 16dp 패딩을 강제로 붙이는데, 좁은 화면(Fold4 커버 = 3탭 × 약 110dp)에서는
                // 남는 폭이 "Directory" + 배지를 담지 못해 배지가 0폭으로 눌리고 "Soon"이
                // 한 글자씩 세로로 접혔다. 콘텐츠 슬롯에는 그 패딩이 없어 한 줄에 들어간다.
                Tab(
                    selected = selectedTab == HomeTab.DIRECTORY,
                    onClick = { onSelectTab(HomeTab.DIRECTORY) },
                    modifier = Modifier.height(44.dp),
                ) {
                    Row(
                        modifier = Modifier.padding(horizontal = 4.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(4.dp),
                    ) {
                        Text(
                            "Directory",
                            style = MaterialTheme.typography.titleSmall,
                            maxLines = 1,
                        )
                        // Placeholder only — Directory has no real billing/entitlement
                        // gate yet (HOTPL_MASTER A-6). Tapping still opens the tab.
                        PremiumSoonBadge()
                    }
                }
                Tab(
                    selected = selectedTab == HomeTab.FRIENDS,
                    onClick = { onSelectTab(HomeTab.FRIENDS) },
                    modifier = Modifier.height(44.dp),
                    text = {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(4.dp),
                        ) {
                            Text("Friends")
                            if (friendsIsAnonymous) {
                                Icon(
                                    Icons.Default.Lock,
                                    contentDescription = "Locked — link your account to use Friends",
                                    modifier = Modifier.size(12.dp),
                                )
                            }
                        }
                    },
                )
            }

            // Shown on every tab, and on the empty state too — a reviewer who has just
            // installed the build has no places yet and is exactly who this is for. It goes
            // away for good once the list is opened, so it costs a line only until read.
            if (hasUnseenChangelog) {
                ChangelogBanner(onClick = onOpenChangelog)
            }

            when (selectedTab) {
                HomeTab.DIRECTORY -> DirectoryScreen(modifier = Modifier.fillMaxSize(), onOpenPlace = onPlaceClick)
                HomeTab.FRIENDS -> if (friendsIsAnonymous) {
                    FriendsLockedPanel(onOpenAccount = onOpenAccount, modifier = Modifier.fillMaxSize())
                } else {
                    FriendsScreen(modifier = Modifier.fillMaxSize())
                }
                HomeTab.JOURNAL -> when {
                    state.loading -> LoadingState(Modifier.fillMaxSize())
                    state.totalCount == 0 -> EmptyPlaces(
                        Modifier.fillMaxSize(),
                        onLoadSample = onLoadSample,
                        showEmptyAccountHint = state.showEmptyAccountHint,
                        onDismissEmptyAccountHint = onDismissEmptyAccountHint,
                    )
                    else -> JournalContent(
                        state = state,
                        queryText = queryText,
                        showSearch = showSearch,
                        showMap = showMap,
                        listState = journalListState,
                        onPlaceClick = onPlaceClick,
                        onSelectPlace = onSelectPlace,
                        onDeletePlace = onDeletePlace,
                        onToggleTag = onToggleTag,
                        onToggleCategory = onToggleCategory,
                        onQueryChange = onQueryChange,
                        onClearFilters = onClearFilters,
                        onToggleLikedFilter = onToggleLikedFilter,
                        onToggleVisitFilter = onToggleVisitFilter,
                        onToggleRechargeEmotion = onToggleRechargeEmotion,
                        emotionLabels = emotionLabels,
                        friendWishNames = friendWishNames,
                        onSelectMostRecentlyVisitedSort = onSelectMostRecentlyVisitedSort,
                        onSelectNearestSort = onSelectNearestSort,
                        onSelectNameSort = onSelectNameSort,
                        onCloseSearch = { showSearch = false },
                        mapContent = mapContent,
                        usageTracker = usageTracker,
                    )
                }
            }
        }
    }

    restorePreview?.let { preview ->
        androidx.compose.material3.AlertDialog(
            onDismissRequest = onDismissRestorePreview,
            title = { Text("Restore backup") },
            text = {
                Text(
                    "This will replace current local data with ${preview.placeCount} places and ${preview.visitCount} visits.",
                )
            },
            confirmButton = {
                TextButton(onClick = onConfirmRestore) { Text("Restore") }
            },
            dismissButton = {
                TextButton(onClick = onDismissRestorePreview) { Text("Cancel") }
            },
        )
    }

    // iOS: the ⋮ overflow opens an action sheet instead of a Material dropdown.
    if (isIosPlatform && showBackupMenu) {
        ModalBottomSheet(onDismissRequest = { showBackupMenu = false }) {
            Column(Modifier.fillMaxWidth().padding(bottom = 24.dp)) {
                BackupSheetAction(if (hasUnseenChangelog) "What's new •" else "What's new") {
                    showBackupMenu = false
                    trackMenuTap("changelog")
                    onOpenChangelog()
                }
                BackupSheetAction("Export backup") {
                    showBackupMenu = false
                    trackMenuTap("export_backup")
                    onExportBackupRequest()
                }
                BackupSheetAction("Restore backup") {
                    showBackupMenu = false
                    trackMenuTap("restore_backup")
                    onRestoreBackupRequest()
                }
                BackupSheetAction("Merge duplicate places") {
                    showBackupMenu = false
                    trackMenuTap("merge_duplicates")
                    onMergeDuplicatesRequest()
                }
                BackupSheetAction("Account") {
                    showBackupMenu = false
                    trackMenuTap("account")
                    onOpenAccount()
                }
            }
        }
    }
}

@Composable
private fun JournalContent(
    state: HomeUiState,
    queryText: String,
    showSearch: Boolean,
    showMap: Boolean,
    listState: LazyListState,
    onPlaceClick: (String) -> Unit,
    onSelectPlace: (String) -> Unit,
    onDeletePlace: (String) -> Unit,
    onToggleTag: (String) -> Unit,
    onToggleCategory: (PlaceCategory) -> Unit,
    onQueryChange: (String) -> Unit,
    onClearFilters: () -> Unit,
    onToggleLikedFilter: () -> Unit,
    onToggleVisitFilter: (HomeVisitFilter) -> Unit,
    onToggleRechargeEmotion: (Emotion) -> Unit,
    emotionLabels: Map<String, String>,
    friendWishNames: Map<String, List<String>>,
    onSelectMostRecentlyVisitedSort: () -> Unit,
    onSelectNearestSort: () -> Unit,
    onSelectNameSort: () -> Unit,
    onCloseSearch: () -> Unit,
    mapContent: @Composable (List<Place>, String?, (String) -> Unit, (String) -> Unit, Modifier) -> Unit,
    usageTracker: UsageTracker = NoOpUsageTracker,
) {
    Column(Modifier.fillMaxSize()) {
        // App-open recall cue: only when not searching/filtering, and only if a
        // milestone actually fires today. No match → nothing renders (no empty banner).
        if (!showSearch && !state.isFiltering) {
            val hasCues = state.recalls.isNotEmpty() ||
                state.revisitCandidates.isNotEmpty() ||
                state.rechargeEmotions.isNotEmpty()
            // Recall + revisit + the feelings picker stack up to most of a phone screen, which
            // leaves the map or list a strip at the bottom. They stay opt-out rather than
            // shrinking: each is a prompt worth reading once a day and worth dismissing for
            // the rest of it. rememberSaveable so the choice survives rotation and tab moves.
            var cuesExpanded by rememberSaveable { mutableStateOf(true) }
            if (hasCues) {
                CuesToggle(
                    expanded = cuesExpanded,
                    onToggle = {
                        cuesExpanded = !cuesExpanded
                        usageTracker.track(UsageEvents.CUES_TOGGLE, mapOf("expanded" to cuesExpanded.toString()))
                    },
                )
            }
            if (hasCues && cuesExpanded) {
                state.recalls.firstOrNull()?.let { recall ->
                    RecallHero(
                        recall = recall,
                        onClick = {
                            usageTracker.track(UsageEvents.CUE_OPEN, mapOf("kind" to "recall"))
                            onPlaceClick(recall.placeId)
                        },
                    )
                }
                // "Good to revisit now" — places whose cadence window is open today.
                // Only surfaces places with an explicit RevisitCadence; coexists with the
                // milestone recall above, never replaces it.
                state.revisitCandidates.firstOrNull()?.let { candidate ->
                    RevisitHero(
                        candidate = candidate,
                        onClick = {
                            usageTracker.track(UsageEvents.CUE_OPEN, mapOf("kind" to "revisit"))
                            onPlaceClick(candidate.placeId)
                        },
                    )
                }
                // 회복 루프 (§1.4): "지금 뭐가 필요해?" — the only cue driven by the user's own
                // state instead of by elapsed time. Renders nothing until visits carry emotions.
                if (state.rechargeEmotions.isNotEmpty()) {
                    RechargePicker(
                        emotions = state.rechargeEmotions,
                        selected = state.selectedRechargeEmotion,
                        candidates = state.rechargeCandidates,
                        onSelect = onToggleRechargeEmotion,
                        onPlaceClick = { id ->
                            usageTracker.track(UsageEvents.CUE_OPEN, mapOf("kind" to "recharge"))
                            onPlaceClick(id)
                        },
                        labels = emotionLabels,
                    )
                }
            }
        }
        // Always-on filter bar: sort-by-distance and the category chips were previously
        // reachable only after opening the search panel, so neither was discoverable at all
        // ("정렬/카테고리가 없다"는 피드백의 실제 원인). Hidden while the search panel is
        // open, which owns the same controls in its own richer layout.
        if (!showSearch) {
            JournalFilterBar(
                visitFilter = state.visitFilter,
                onToggleVisitFilter = onToggleVisitFilter,
                categories = state.availableCategories,
                selectedCategories = state.selectedCategories,
                onToggleCategory = onToggleCategory,
                sortMode = state.sortMode,
                onSelectNearestSort = onSelectNearestSort,
                onSelectNameSort = onSelectNameSort,
                selectedTags = state.selectedTags,
                onToggleTag = onToggleTag,
            )
        }
        if (showSearch) {
            SearchFilters(
                query = queryText,
                onQueryChange = onQueryChange,
                showClearAction = state.hasActiveFiltersOrSort,
                onClearFilters = onClearFilters,
                sortMode = state.sortMode,
                onSelectMostRecentlyVisitedSort = onSelectMostRecentlyVisitedSort,
                onSelectNearestSort = onSelectNearestSort,
                onSelectNameSort = onSelectNameSort,
                likedFilter = state.likedFilter,
                onToggleLikedFilter = onToggleLikedFilter,
                visitFilter = state.visitFilter,
                onToggleVisitFilter = onToggleVisitFilter,
                allTags = state.allTags,
                selectedTags = state.selectedTags,
                onToggleTag = onToggleTag,
                onCloseSearch = onCloseSearch,
            )
        }
        ResultsSummary(
            text = buildResultsSummary(
                totalCount = state.totalCount,
                visibleCount = state.visibleCount,
                sortMode = state.sortMode,
                hasActiveFilters = state.isFiltering,
            ),
        )
        val sectionModifier = Modifier.fillMaxSize()
        when {
            state.places.isEmpty() -> NoResults(
                modifier = sectionModifier,
                showClearAction = state.hasActiveFiltersOrSort,
                onClearFilters = onClearFilters,
            )
            showMap -> Box(sectionModifier) {
                mapContent(
                    state.places,
                    state.selectedPlaceId,
                    onSelectPlace,
                    onPlaceClick,
                    Modifier.fillMaxSize(),
                )
                // The map's own marker bubbles disappear once markers are clustered, so the
                // "which place is this pin?" answer is drawn here instead. Top-aligned to
                // clear the zoom controls and the Add-place FAB at the bottom, and inset at
                // the end so it never runs under the my-location button.
                state.places.firstOrNull { it.id == state.selectedPlaceId }?.let { place ->
                    SelectedPlaceBanner(
                        place = place,
                        onOpen = { onPlaceClick(place.id) },
                        modifier = Modifier
                            .align(Alignment.TopStart)
                            .padding(start = 12.dp, end = 72.dp, top = 12.dp),
                    )
                }
            }
            else -> PlaceList(
                places = state.places,
                visitSummaries = state.visitSummaries,
                friendWishNames = friendWishNames,
                selectedTags = state.selectedTags,
                selectedPlaceId = state.selectedPlaceId,
                listState = listState,
                alphabetIndex = state.alphabetIndex,
                onPlaceClick = onPlaceClick,
                onDeletePlace = onDeletePlace,
                onToggleTag = onToggleTag,
                modifier = sectionModifier,
            )
        }
    }
}

/** Full-width tappable row used inside the iOS backup action sheet. */
@Composable
private fun BackupSheetAction(label: String, onClick: () -> Unit) {
    Text(
        text = label,
        style = MaterialTheme.typography.bodyLarge,
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = 24.dp, vertical = 16.dp),
    )
}

@Composable
private fun ResultsSummary(
    text: String,
    modifier: Modifier = Modifier,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .testTag("home-results-summary"),
    )
}

/**
 * Names the pin the user just tapped, and opens it on a second tap — the two-step the map's
 * own info window used to provide before clustering took it away.
 */
@Composable
private fun SelectedPlaceBanner(place: Place, onOpen: () -> Unit, modifier: Modifier = Modifier) {
    Card(
        modifier = modifier
            .clickable(onClick = onOpen)
            .testTag("map-selected-banner"),
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 14.dp, vertical = 10.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(10.dp),
        ) {
            Column(Modifier.weight(1f, fill = false)) {
                Text(
                    text = place.name,
                    style = MaterialTheme.typography.titleMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                place.locationContext?.takeIf { it.isNotBlank() }?.let { context ->
                    Text(
                        text = context,
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
            }
            Text(
                text = "Open",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary,
            )
        }
    }
}

/** One-line "this build changed things" cue, shown until the changelog is opened. */
@Composable
private fun ChangelogBanner(onClick: () -> Unit, modifier: Modifier = Modifier) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .background(MaterialTheme.colorScheme.secondaryContainer)
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp, vertical = 10.dp)
            .testTag("changelog-banner"),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        Text(
            text = "What's new in this build",
            style = MaterialTheme.typography.labelLarge,
            color = MaterialTheme.colorScheme.onSecondaryContainer,
        )
        Text(
            text = "Read",
            style = MaterialTheme.typography.labelLarge,
            color = MaterialTheme.colorScheme.onSecondaryContainer,
        )
    }
}

/** Collapses the recall/revisit/feelings prompts so the list or map can own the screen. */
@Composable
private fun CuesToggle(expanded: Boolean, onToggle: () -> Unit, modifier: Modifier = Modifier) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .clickable(onClick = onToggle)
            .padding(horizontal = 16.dp, vertical = 4.dp)
            .testTag("home-cues-toggle"),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        Text(
            text = "Suggestions",
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Icon(
            imageVector = if (expanded) Icons.Default.KeyboardArrowUp else Icons.Default.KeyboardArrowDown,
            contentDescription = if (expanded) "Hide suggestions" else "Show suggestions",
            tint = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

/**
 * One-line, horizontally scrollable filter bar shown above the results on the Journal tab:
 * "Nearest" (the location sort) followed by a chip per [PlaceCategory] actually present in
 * the user's places. Categories are inferred from tags, so this row is empty for a journal
 * whose places carry no recognizable tag — by design, not an error state.
 */
@Composable
private fun JournalFilterBar(
    visitFilter: HomeVisitFilter,
    onToggleVisitFilter: (HomeVisitFilter) -> Unit,
    categories: List<PlaceCategory>,
    selectedCategories: Set<PlaceCategory>,
    onToggleCategory: (PlaceCategory) -> Unit,
    sortMode: HomeSortMode,
    onSelectNearestSort: () -> Unit,
    onSelectNameSort: () -> Unit,
    /** 켜져 있는 태그 필터. 검색 패널이 접혀 있어도 여기서는 보여야 한다 — 아래 설명. */
    selectedTags: Set<String> = emptySet(),
    onToggleTag: (String) -> Unit = {},
    modifier: Modifier = Modifier,
) {
    val chipShape = if (isIosPlatform) RoundedCornerShape(percent = 50) else FilterChipDefaults.shape
    Row(
        modifier = modifier
            .fillMaxWidth()
            .horizontalScroll(rememberScrollState())
            .padding(horizontal = 16.dp, vertical = 4.dp)
            .testTag("home-filter-bar"),
        horizontalArrangement = Arrangement.spacedBy(6.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        // ── 켜진 태그 필터는 언제나, 그리고 맨 앞에 ────────────────────────── ──────────────────────────────
        // 태그 칩은 검색 패널 안에만 있었는데, 목록 카드의 태그를 누르면 그 패널이 닫힌
        // 채로도 필터가 켜진다. 그래서 카드를 열려다 태그를 스쳐 누르면 **화면에 아무
        // 단서도 없이** 목록이 비었다(리뷰어 2026-09-09, R-14 — 개발자도 겪음).
        // 켜진 태그를 여기 그대로 세워 두면, 무엇이 목록을 비웠는지 보이고 한 번 더
        // 눌러 끌 수 있다. **줄 맨 앞**인 이유는 실기기에서 확인한 것이다 — 카테고리
        // 칩 뒤에 붙였더니 가로 스크롤 밖으로 밀려나 또 안 보였다.
        selectedTags.sorted().forEach { tag ->
            FilterChip(
                selected = true,
                onClick = { onToggleTag(tag) },
                label = { Text(tag) },
                trailingIcon = {
                    Icon(Icons.Default.Close, contentDescription = null, modifier = Modifier.size(16.dp))
                },
                shape = chipShape,
                modifier = Modifier.testTag("home-active-tag-$tag"),
            )
        }
        // 가본 곳 / 안 가본 곳 (R-11). 정렬·카테고리보다 앞 — 리뷰어 말대로 "그날 찾는 쪽"을
        // 먼저 고르고 그 안에서 정렬한다. 켜진 태그 칩 뒤인 이유는 위와 같다(R-14).
        VisitFilterChips(visitFilter, onToggleVisitFilter, chipShape)
        FilterChip(
            selected = sortMode == HomeSortMode.NEAREST,
            onClick = onSelectNearestSort,
            leadingIcon = {
                Icon(Icons.Default.LocationOn, contentDescription = null, modifier = Modifier.size(18.dp))
            },
            label = { Text("Nearest") },
            shape = chipShape,
            modifier = Modifier.testTag("home-filter-nearest"),
        )
        // 이름순은 색인 레일의 전제다 — 거리순 목록에서 "M"을 눌러 봐야 갈 곳이 없다(R-10).
        FilterChip(
            selected = sortMode == HomeSortMode.NAME,
            onClick = onSelectNameSort,
            label = { Text("A–Z") },
            shape = chipShape,
            modifier = Modifier.testTag("home-filter-name"),
        )
        categories.forEach { category ->
            FilterChip(
                selected = category in selectedCategories,
                onClick = { onToggleCategory(category) },
                label = { Text(category.label) },
                shape = chipShape,
                modifier = Modifier.testTag("home-filter-category-" + category.name),
            )
        }
    }
}

@Composable
private fun VisitFilterChips(
    visitFilter: HomeVisitFilter,
    onToggle: (HomeVisitFilter) -> Unit,
    chipShape: Shape,
) {
    FilterChip(
        selected = visitFilter == HomeVisitFilter.BEEN,
        onClick = { onToggle(HomeVisitFilter.BEEN) },
        // 지도 핀 그대로 — 칩이 곧 범례다. 속 찬 빨강 = 가본 곳, 속 빈 흰 핀 = 안 가본 곳.
        leadingIcon = { PlacePinIcon(hollow = false) },
        label = { Text("Been") },
        shape = chipShape,
        modifier = Modifier.testTag("home-filter-been"),
    )
    FilterChip(
        selected = visitFilter == HomeVisitFilter.WANT_TO_GO,
        onClick = { onToggle(HomeVisitFilter.WANT_TO_GO) },
        leadingIcon = { PlacePinIcon(hollow = true) },
        label = { Text("Want to go") },
        shape = chipShape,
        modifier = Modifier.testTag("home-filter-want-to-go"),
    )
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun SearchFilters(
    query: String,
    onQueryChange: (String) -> Unit,
    showClearAction: Boolean,
    onClearFilters: () -> Unit,
    sortMode: HomeSortMode,
    onSelectMostRecentlyVisitedSort: () -> Unit,
    onSelectNearestSort: () -> Unit,
    onSelectNameSort: () -> Unit,
    likedFilter: Boolean? = null,
    onToggleLikedFilter: () -> Unit = {},
    visitFilter: HomeVisitFilter = HomeVisitFilter.ALL,
    onToggleVisitFilter: (HomeVisitFilter) -> Unit = {},
    allTags: List<String>,
    selectedTags: Set<String>,
    onToggleTag: (String) -> Unit,
    onCloseSearch: () -> Unit = {},
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 8.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        var showAllTags by rememberSaveable(allTags, selectedTags) { mutableStateOf(false) }
        val visibleTags = visibleHomeFilterTags(
            allTags = allTags,
            selectedTags = selectedTags,
            showAllTags = showAllTags,
        )
        val hiddenTagCount = (allTags.size - visibleTags.size).coerceAtLeast(0)

        /**
         * ── 한글 IME 입력 순서 뒤집힘 ──────────────────────
         *  · 필드의 편집 상태(텍스트 + 커서/선택 + 조합 중인 음절)는 컴포저블이
         *    로컬로 소유하고, ViewModel로는 한 방향으로만 흘려보낸다. query를
         *    value로 되돌려 받으면 한 프레임 늦게 도착한 값이 조합 중인 음절을
         *    끊어, 커서가 앞으로 밀리고 글자 순서가 뒤집힌다.
         *  · query를 비우는 경로(Clear 아이콘, Clear 칩, iOS Cancel)는 모두 이
         *    컴포저블 안에 있으므로, 그때만 로컬 상태를 같이 비워 주면 된다.
         */
        var field by remember { mutableStateOf(TextFieldValue(query, TextRange(query.length))) }
        val setQuery: (String) -> Unit = { text ->
            field = TextFieldValue(text, TextRange(text.length))
            onQueryChange(text)
        }

        val clearIcon: @Composable () -> Unit = {
            if (field.text.isNotEmpty()) {
                IconButton(
                    onClick = { setQuery("") },
                    modifier = Modifier.testTag("home-search-clear"),
                ) {
                    Icon(Icons.Default.Close, contentDescription = "Clear search")
                }
            }
        }
        if (isIosPlatform) {
            // iOS HIG: a rounded (capsule) search field with a leading magnifier, and a
            // trailing "Cancel" that dismisses the search (collapses the panel).
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(4.dp),
            ) {
                OutlinedTextField(
                    value = field,
                    onValueChange = { field = it; onQueryChange(it.text) },
                    placeholder = { Text("Search") },
                    singleLine = true,
                    shape = RoundedCornerShape(percent = 50),
                    leadingIcon = { Icon(Icons.Default.Search, contentDescription = null) },
                    trailingIcon = clearIcon,
                    modifier = Modifier
                        .weight(1f)
                        .testTag("home-search-field"),
                )
                TextButton(onClick = {
                    setQuery("")
                    onCloseSearch()
                }) {
                    Text("Cancel")
                }
            }
        } else {
            OutlinedTextField(
                value = field,
                onValueChange = { field = it; onQueryChange(it.text) },
                placeholder = { Text("Search by place name") },
                singleLine = true,
                trailingIcon = clearIcon,
                modifier = Modifier
                    .fillMaxWidth()
                    .testTag("home-search-field"),
            )
        }
        // iOS HIG leans to pill-shaped controls; Android keeps the Material chip shape.
        val chipShape = if (isIosPlatform) RoundedCornerShape(percent = 50) else FilterChipDefaults.shape
        FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
            VisitFilterChips(visitFilter, onToggleVisitFilter, chipShape)
            FilterChip(
                selected = sortMode == HomeSortMode.MOST_RECENT,
                onClick = onSelectMostRecentlyVisitedSort,
                label = { Text("Most recently visited") },
                shape = chipShape,
            )
            FilterChip(
                selected = sortMode == HomeSortMode.NAME,
                onClick = onSelectNameSort,
                label = { Text("Name A–Z") },
            )
            FilterChip(
                selected = sortMode == HomeSortMode.NEAREST,
                onClick = onSelectNearestSort,
                label = { Text("Nearest to me") },
                shape = chipShape,
            )
            FilterChip(
                selected = likedFilter != null,
                onClick = onToggleLikedFilter,
                leadingIcon = {
                    Icon(
                        if (likedFilter == false) Icons.Default.FavoriteBorder else Icons.Default.Favorite,
                        contentDescription = null,
                    )
                },
                label = {
                    Text(
                        when (likedFilter) {
                            null -> "Revisit soon"
                            true -> "Revisit soon only"
                            false -> "Not marked"
                        },
                    )
                },
                shape = chipShape,
            )
            if (showClearAction) {
                // clearFilters() resets the ViewModel query too, so the field has to follow.
                TextButton(onClick = {
                    field = TextFieldValue("")
                    onClearFilters()
                }) {
                    Text("Clear")
                }
            }
        }
        if (allTags.isNotEmpty()) {
            Text(
                text = "Filter by tag",
                style = MaterialTheme.typography.labelSmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                visibleTags.forEach { tag ->
                    FilterChip(
                        selected = tag in selectedTags,
                        onClick = { onToggleTag(tag) },
                        modifier = Modifier.testTag("home-filter-tag-$tag"),
                        label = { Text(tag) },
                        shape = chipShape,
                    )
                }
                val hasOverflow = allTags.size > MAX_COLLAPSED_HOME_FILTER_TAGS
                when {
                    // Collapsed with more tags than the limit: offer to expand.
                    hasOverflow && !showAllTags -> TextButton(
                        onClick = { showAllTags = true },
                        modifier = Modifier.testTag("home-filter-more"),
                    ) {
                        Text("+$hiddenTagCount more")
                    }
                    // Expanded with more tags than the limit: offer to collapse.
                    hasOverflow && showAllTags -> TextButton(
                        onClick = { showAllTags = false },
                        modifier = Modifier.testTag("home-filter-less"),
                    ) {
                        Text("Less")
                    }
                }
            }
        }
    }
}

@Composable
private fun LoadingState(modifier: Modifier = Modifier) {
    Box(modifier, contentAlignment = Alignment.Center) {
        CircularProgressIndicator()
    }
}

@Composable
private fun EmptyPlaces(
    modifier: Modifier = Modifier,
    onLoadSample: () -> Unit = {},
    showEmptyAccountHint: Boolean = false,
    onDismissEmptyAccountHint: () -> Unit = {},
) {
    Box(modifier.padding(24.dp), contentAlignment = Alignment.Center) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text(
                text = "No saved places yet",
                style = MaterialTheme.typography.titleMedium,
            )
            Spacer(Modifier.height(8.dp))
            if (showEmptyAccountHint) {
                Text(
                    text = "This account has no saved places. If you expected to see your places, " +
                        "check that you're signed in with the right account in Settings.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    textAlign = TextAlign.Center,
                )
                Spacer(Modifier.height(8.dp))
                TextButton(onClick = onDismissEmptyAccountHint) {
                    Text("Got it")
                }
                Spacer(Modifier.height(12.dp))
            } else {
                Text(
                    text = "Tap Add place to save the first spot you want to remember.",
                    style = MaterialTheme.typography.bodyMedium,
                    textAlign = TextAlign.Center,
                )
            }
            Spacer(Modifier.height(20.dp))
            Text(
                text = "Just exploring? Load a sample set of LA Koreatown cafes and restaurants.",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                textAlign = TextAlign.Center,
            )
            Spacer(Modifier.height(8.dp))
            Button(
                onClick = onLoadSample,
                modifier = Modifier.testTag("home-load-sample"),
            ) {
                Text("Load sample places")
            }
        }
    }
}

@Composable
private fun NoResults(
    modifier: Modifier = Modifier,
    showClearAction: Boolean = false,
    onClearFilters: () -> Unit = {},
) {
    Box(modifier.padding(24.dp), contentAlignment = Alignment.Center) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text(
                text = "No matching places",
                style = MaterialTheme.typography.titleMedium,
            )
            Spacer(Modifier.height(8.dp))
            Text(
                text = "Try a different place name or clear a tag filter.",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                textAlign = TextAlign.Center,
            )
            if (showClearAction) {
                Spacer(Modifier.height(12.dp))
                TextButton(
                    onClick = onClearFilters,
                    modifier = Modifier.testTag("home-no-results-clear"),
                ) {
                    Text("Clear")
                }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun PlaceList(
    places: List<Place>,
    visitSummaries: Map<String, PlaceVisitSummary>,
    friendWishNames: Map<String, List<String>>,
    selectedTags: Set<String>,
    selectedPlaceId: String?,
    onPlaceClick: (String) -> Unit,
    onDeletePlace: (String) -> Unit,
    onToggleTag: (String) -> Unit,
    modifier: Modifier = Modifier,
    listState: LazyListState = rememberLazyListState(),
    /** 글자 → 첫 항목 인덱스. 비어 있으면 레일을 안 그린다(이름순이 아닐 때). */
    alphabetIndex: Map<Char, Int> = emptyMap(),
) {
    // Swiping a card requests deletion; we confirm first because it also drops visit history.
    var placePendingDelete by remember { mutableStateOf<Place?>(null) }
    val showRail = alphabetIndex.size > 1 && places.size >= MIN_PLACES_FOR_ALPHABET_RAIL
    val scope = rememberCoroutineScope()

    Box(modifier) {
    LazyColumn(
        modifier = Modifier
            .fillMaxSize()
            // 레일이 서면 목록에 그만큼 자리를 내준다 — 카드 오른쪽 끝이 글자에 가리지 않게.
            .padding(end = if (showRail) ALPHABET_RAIL_WIDTH else 0.dp),
        state = listState,
        contentPadding = PaddingValues(start = 16.dp, end = 16.dp, top = 16.dp, bottom = 88.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp),
    ) {
        items(places, key = { it.id }) { place ->
            val dismissState = rememberSwipeToDismissBoxState(
                confirmValueChange = { value ->
                    if (value == SwipeToDismissBoxValue.EndToStart) {
                        placePendingDelete = place
                    }
                    // Never auto-dismiss: the row snaps back and the dialog drives the delete.
                    false
                },
            )
            SwipeToDismissBox(
                state = dismissState,
                modifier = Modifier.testTag("place-swipe-${place.id}"),
                enableDismissFromStartToEnd = false,
                backgroundContent = { SwipeToDeleteBackground() },
            ) {
                PlaceCard(
                    place = place,
                    visitSummary = visitSummaries[place.id],
                    friendWishNames = friendWishNames[place.id].orEmpty(),
                    selectedTags = selectedTags,
                    selected = place.id == selectedPlaceId,
                    onClick = { onPlaceClick(place.id) },
                    onToggleTag = onToggleTag,
                )
            }
        }
    }

        if (showRail) {
            AlphabetRail(
                letters = alphabetIndex.keys.sortedWith(compareBy({ it == OTHER_BUCKET }, { it })),
                onLetter = { letter ->
                    alphabetIndex[letter]?.let { index ->
                        scope.launch { listState.scrollToItem(index) }
                    }
                },
                modifier = Modifier.align(Alignment.CenterEnd),
            )
        }
    }

    placePendingDelete?.let { place ->
        AlertDialog(
            onDismissRequest = { placePendingDelete = null },
            title = { Text("Delete place?") },
            text = { Text("Delete \"${place.name}\" and all its visit history? This can't be undone.") },
            confirmButton = {
                TextButton(
                    onClick = {
                        onDeletePlace(place.id)
                        placePendingDelete = null
                    },
                    modifier = Modifier.testTag("place-delete-confirm"),
                ) {
                    Text("Delete")
                }
            },
            dismissButton = {
                TextButton(onClick = { placePendingDelete = null }) {
                    Text("Cancel")
                }
            },
        )
    }
}

/**
 * 목록 오른쪽 가장자리의 A-Z 색인. 글자를 누르거나 위아래로 훑으면 그 구간으로 뛴다.
 *
 * ── 왜 26자를 다 세우지 않는가 ──────────────────────────────
 * 실제로 있는 글자만 담는다([alphabetIndex]). iOS 앱 보관함은 수백 개를 전제로 26자를
 * 전부 세우지만, 장소가 열댓 개인 목록 옆에서는 레일이 목록보다 길어진다. 빈 글자를 눌러
 * 아무 일도 안 일어나는 것보다, 없는 글자는 아예 안 보이는 편이 낫다.
 *
 * ── 스와이프 삭제와 같은 자리에 산다 ──────────────────────────────
 * 목록 행은 **오른쪽에서 왼쪽으로** 밀어 삭제하는데, 레일도 오른쪽 가장자리다. 그래서
 * 레일은 [ALPHABET_RAIL_WIDTH]로 좁게 잡고 자기 제스처를 소비하며, 목록에는 그만큼
 * 패딩을 줘서 카드가 레일 밑으로 들어가지 않게 한다 — 손가락이 카드 위에서 시작하면
 * 삭제, 글자 위에서 시작하면 색인이다.
 */
@Composable
private fun AlphabetRail(
    letters: List<Char>,
    onLetter: (Char) -> Unit,
    modifier: Modifier = Modifier,
) {
    var height by remember { mutableStateOf(0) }
    // 훑는 동안 같은 글자로 계속 점프 요청이 나가지 않게 마지막으로 보낸 글자를 기억한다.
    var lastSent by remember(letters) { mutableStateOf<Char?>(null) }

    fun letterAt(y: Float): Char? {
        if (height <= 0 || letters.isEmpty()) return null
        val slot = (y / height * letters.size).toInt().coerceIn(0, letters.lastIndex)
        return letters[slot]
    }

    Column(
        modifier = modifier
            .width(ALPHABET_RAIL_WIDTH)
            .padding(vertical = 24.dp)
            .onSizeChanged { height = it.height }
            .testTag("alphabet-rail")
            .pointerInput(letters) {
                detectVerticalDragGestures(
                    onDragStart = { start -> letterAt(start.y)?.let { lastSent = it; onLetter(it) } },
                    onDragEnd = { lastSent = null },
                    onDragCancel = { lastSent = null },
                ) { change, _ ->
                    change.consume()
                    letterAt(change.position.y)?.let { if (it != lastSent) { lastSent = it; onLetter(it) } }
                }
            }
            .pointerInput(letters) {
                detectTapGestures { tap -> letterAt(tap.y)?.let(onLetter) }
            },
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(2.dp, Alignment.CenterVertically),
    ) {
        letters.forEach { letter ->
            Text(
                text = letter.toString(),
                style = MaterialTheme.typography.labelSmall,
                color = MaterialTheme.colorScheme.primary,
            )
        }
    }
}

/** 좁게 잡는다 — 이 폭이 곧 스와이프 삭제에게서 뺏어 오는 자리다. */
private val ALPHABET_RAIL_WIDTH = 24.dp

/**
 * The single app-open recall cue at the top of home: a quiet milestone line
 * ("A year ago today") over the place name, tappable to reopen the place. Emotion
 * tags / notes are intentionally omitted here — they need a schema this cue does not.
 */
@Composable
private fun RecallHero(recall: RecallCandidate, onClick: () -> Unit) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = 16.dp, end = 16.dp, top = 16.dp)
            .testTag("recall-hero")
            .clickable(onClick = onClick),
    ) {
        Column(Modifier.padding(16.dp)) {
            Text(
                text = recall.line,
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.primary,
            )
            Spacer(Modifier.height(4.dp))
            Text(
                text = recall.placeName,
                style = MaterialTheme.typography.titleLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }
    }
}

/**
 * The "good to revisit now" cue: a place whose [fyi.moko.hotpl.domain.model.RevisitCadence]
 * window is open today. Quietly coexists with [RecallHero] — never replaces the milestone
 * recall. Only one place is shown (the most overdue); no empty banner when the list is empty.
 */
@Composable
private fun RevisitHero(candidate: RevisitCandidate, onClick: () -> Unit) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = 16.dp, end = 16.dp, top = 8.dp)
            .testTag("revisit-hero")
            .clickable(onClick = onClick),
    ) {
        Column(Modifier.padding(16.dp)) {
            Text(
                text = "Good to revisit · ${candidate.cadenceLabel}",
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.tertiary,
            )
            Spacer(Modifier.height(4.dp))
            Text(
                text = candidate.placeName,
                style = MaterialTheme.typography.titleLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }
    }
}

/**
 * The 회복 루프 entry point (`HOTPL_MASTER.md` §1.4, backlog `A-9`): pick the feeling you
 * need now, get back the places that actually gave it to you.
 *
 * Unlike [RecallHero] and [RevisitHero] — which decide *for* the user based on elapsed time —
 * this cue waits to be asked. Nothing is selected by default, so the resting state is a single
 * quiet row of dots; the answer list only appears on a tap. Only emotions present in the user's
 * own history are offered, so there are never dead chips.
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun RechargePicker(
    emotions: List<Emotion>,
    selected: Emotion?,
    candidates: List<RechargeCandidate>,
    onSelect: (Emotion) -> Unit,
    onPlaceClick: (String) -> Unit,
    labels: Map<String, String> = emptyMap(),
) {
    Column(
        Modifier
            .fillMaxWidth()
            .padding(start = 16.dp, end = 16.dp, top = 8.dp)
            .testTag("recharge-picker"),
    ) {
        Text(
            text = "What do you need right now?",
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Spacer(Modifier.height(8.dp))
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            emotions.forEach { emotion ->
                FilterChip(
                    selected = emotion == selected,
                    onClick = { onSelect(emotion) },
                    label = { Text(emotion.displayLabel(labels)) },
                    leadingIcon = {
                        Box(
                            Modifier
                                .size(10.dp)
                                .clip(CircleShape)
                                .background(emotion.dotColor),
                        )
                    },
                    modifier = Modifier.testTag("recharge-chip-${emotion.id}"),
                )
            }
        }
        if (selected != null) {
            Spacer(Modifier.height(8.dp))
            Card(Modifier.fillMaxWidth().testTag("recharge-results")) {
                Column(Modifier.padding(vertical = 4.dp)) {
                    if (candidates.isEmpty()) {
                        // Reachable only in the moment between deleting the last matching visit
                        // and the flow re-emitting; the selection is dropped on the next tick.
                        Text(
                            text = "Nothing recorded yet",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp),
                        )
                    }
                    candidates.take(MAX_RECHARGE_RESULTS).forEach { candidate ->
                        RechargeResultRow(
                            candidate = candidate,
                            onClick = { onPlaceClick(candidate.placeId) },
                        )
                    }
                }
            }
        }
    }
}

/** How many answers the recharge card shows — enough to choose between, short of a list to scroll. */
private const val MAX_RECHARGE_RESULTS = 5

@Composable
private fun RechargeResultRow(candidate: RechargeCandidate, onClick: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .testTag("recharge-result-${candidate.placeId}")
            .padding(horizontal = 16.dp, vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Text(
            text = candidate.placeName,
            style = MaterialTheme.typography.bodyLarge,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(1f),
        )
        Spacer(Modifier.width(8.dp))
        Text(
            text = rechargeStrengthLabel(candidate),
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

/**
 * "3 of 5 visits" — the evidence behind the ranking, stated plainly. A place matched on every
 * visit reads as "every visit" instead, which is the stronger and shorter claim.
 */
internal fun rechargeStrengthLabel(candidate: RechargeCandidate): String = when {
    candidate.matchingVisitCount == candidate.totalVisitCount && candidate.totalVisitCount > 1 -> "every visit"
    candidate.totalVisitCount == 1 -> "once"
    else -> "${candidate.matchingVisitCount} of ${candidate.totalVisitCount} visits"
}

/** Red trailing background revealed when a place card is swiped left, signalling delete. */
@Composable
private fun SwipeToDeleteBackground() {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .clip(MaterialTheme.shapes.medium)
            .background(MaterialTheme.colorScheme.errorContainer)
            .padding(horizontal = 24.dp),
        contentAlignment = Alignment.CenterEnd,
    ) {
        Text(
            text = "Delete",
            style = MaterialTheme.typography.labelLarge,
            color = MaterialTheme.colorScheme.onErrorContainer,
        )
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun PlaceCard(
    place: Place,
    visitSummary: PlaceVisitSummary?,
    friendWishNames: List<String>,
    selectedTags: Set<String>,
    selected: Boolean,
    onClick: () -> Unit,
    onToggleTag: (String) -> Unit,
) {
    val visibleTags = prioritizedCardTags(place.tags, selectedTags).take(MAX_VISIBLE_CARD_TAGS)
    val hiddenTagCount = (place.tags.size - visibleTags.size).coerceAtLeast(0)

    // Frequency as temperature (PROJECT.md §4-⑥): the baseline card tone is the floor so
    // separation is never lost; often-visited places warm subtly toward the brand color.
    val baseTone = MaterialTheme.colorScheme.surfaceContainerHigh
    val warmPeak = lerp(baseTone, MaterialTheme.colorScheme.primary, 0.16f)
    val glowTone = lerp(baseTone, warmPeak, visitGlowFraction(visitSummary?.visitCount ?: 1))

    Card(
        modifier = Modifier
            .fillMaxWidth()
            .testTag("place-card-${place.id}")
            .semantics { this.selected = selected }
            .clickable(onClick = onClick),
        shape = RoundedCornerShape(8.dp),
        border = if (selected) BorderStroke(1.dp, MaterialTheme.colorScheme.primary) else null,
        // Subtle elevation lifts each card off the dark background; the container tone
        // additionally carries the visit-frequency glow (selection overrides it).
        colors = CardDefaults.cardColors(
            containerColor = if (selected) MaterialTheme.colorScheme.primaryContainer else glowTone,
        ),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp),
    ) {
        Column(Modifier.padding(16.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(6.dp),
                    modifier = Modifier.weight(1f),
                ) {
                    // Last visit's emotion as a quiet color dot — a separate channel from
                    // any visit-frequency signal, and only rendered when one was picked.
                    visitSummary?.emotion?.let { emotion ->
                        Box(
                            modifier = Modifier
                                .size(10.dp)
                                .clip(CircleShape)
                                .background(emotion.dotColor)
                                .testTag("place-card-${place.id}-emotion-dot"),
                        )
                    }
                    Text(place.name, style = MaterialTheme.typography.titleMedium)
                }
                // Revisit intent only applies after a recorded visit. Checking both status
                // and summary also handles legacy "to try" records whose status defaulted
                // to VISITED even though they never had a visit.
                if (
                    place.status == PlaceStatus.VISITED &&
                    visitSummary?.visitCount?.let { it > 0 } == true &&
                    place.liked
                ) {
                    RevisitSoonBadge(onSelectedCard = selected)
                }
            }
            // Only show a location line when there's a real place/neighborhood name;
            // a generic "saved" badge is redundant (everything in the list is saved).
            val locationContext = place.locationContext
            if (!locationContext.isNullOrBlank()) {
                Spacer(Modifier.height(4.dp))
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(4.dp),
                ) {
                    Icon(
                        Icons.Default.Place,
                        contentDescription = null,
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                        modifier = Modifier.size(14.dp),
                    )
                    Text(
                        text = locationContext,
                        // bodySmall (Regular) vs the labelSmall (Medium) tags/date below —
                        // the card's secondary lines shouldn't all share one style.
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
            }
            // Note (often an address dump) is intentionally omitted here to keep the
            // list focused on name → recency → tags; the full note lives on the detail screen.
            visitSummary?.let { summary ->
                Spacer(Modifier.height(6.dp))
                // YouTube-style relative recency ("3 weeks ago") reads faster than an
                // absolute date; computed once per composition against the current time.
                val now = remember(summary.lastVisitedAt) { Clock.System.now().toEpochMilliseconds() }
                Text(
                    // Visit count is now carried by the card glow, not a number.
                    text = "Visited ${lastVisitPhrase(summary.lastVisitedAt, now)}",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            if (friendWishNames.isNotEmpty()) {
                Spacer(Modifier.height(6.dp))
                FriendWishBadge(
                    names = friendWishNames,
                    onSelectedCard = selected,
                    modifier = Modifier.testTag("place-card-${place.id}-friend-wish"),
                )
            }
            if (place.tags.isNotEmpty()) {
                Spacer(Modifier.height(6.dp))
                FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(6.dp),
                    verticalArrangement = Arrangement.spacedBy(4.dp),
                ) {
                    visibleTags.forEach { tag ->
                        CardTagChip(
                            tag = tag,
                            selected = tag in selectedTags,
                            onClick = { onToggleTag(tag) },
                            modifier = Modifier.testTag("place-card-${place.id}-tag-$tag"),
                        )
                    }
                    if (hiddenTagCount > 0) {
                        HiddenTagCountChip(
                            count = hiddenTagCount,
                            modifier = Modifier.testTag("place-card-${place.id}-tag-overflow"),
                        )
                    }
                }
            }
        }
    }
}

/**
 * Heart = revisit intent (appbar design doc 2026-07-19): promoted from a bare icon to a
 * labeled badge so the meaning reads without prior knowledge — and sparse cards get a
 * second content line for free.
 */
@Composable
private fun RevisitSoonBadge(onSelectedCard: Boolean = false, modifier: Modifier = Modifier) {
    CardBadge(
        icon = Icons.Default.Favorite,
        text = "Revisit soon",
        tone = if (onSelectedCard) MaterialTheme.colorScheme.onPrimaryContainer else MaterialTheme.colorScheme.primary,
        modifier = modifier,
    )
}

/**
 * The card's small pill badges share one shape. [tone] is both the ink and the tint of the
 * pill — on a selected card (primaryContainer) the callers pass onPrimaryContainer, because
 * the tertiary/primary inks these use on a resting card vanish against that orange.
 */
@Composable
private fun CardBadge(
    icon: ImageVector,
    text: String,
    tone: Color,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier
            .clip(RoundedCornerShape(percent = 50))
            .background(tone.copy(alpha = 0.12f))
            .padding(horizontal = 8.dp, vertical = 3.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
    ) {
        Icon(icon, contentDescription = null, tint = tone, modifier = Modifier.size(12.dp))
        Text(text = text, style = MaterialTheme.typography.labelSmall, color = tone, maxLines = 1)
    }
}

/**
 * A friend who also wants to go here (0-37 stage 2), named only — the person icon carries
 * the verb, and the full "wants to go too" sentence is on Detail. Same shape as
 * [RevisitSoonBadge] in the tertiary tone, so it reads as social rather than as my own
 * intent. Network-fed — absent offline, never a placeholder.
 */
@Composable
private fun FriendWishBadge(names: List<String>, onSelectedCard: Boolean = false, modifier: Modifier = Modifier) {
    CardBadge(
        icon = Icons.Default.Person,
        text = mutualWishNames(names),
        tone = if (onSelectedCard) MaterialTheme.colorScheme.onPrimaryContainer else MaterialTheme.colorScheme.tertiary,
        modifier = modifier,
    )
}

@Composable
private fun CardTagChip(
    tag: String,
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val shape = if (isIosPlatform) RoundedCornerShape(percent = 50) else RoundedCornerShape(14.dp)
    val borderColor = if (selected) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.outlineVariant
    val containerColor = if (selected) {
        MaterialTheme.colorScheme.primaryContainer
    } else {
        MaterialTheme.colorScheme.surfaceVariant
    }
    val contentColor = if (selected) MaterialTheme.colorScheme.onPrimaryContainer else MaterialTheme.colorScheme.onSurfaceVariant

    Row(
        modifier = modifier
            .clip(shape)
            .background(containerColor)
            .border(BorderStroke(1.dp, borderColor), shape)
            .semantics { this.selected = selected }
            .clickable(
                role = Role.Button,
                onClickLabel = if (selected) "Remove $tag filter" else "Filter by $tag",
                onClick = onClick,
            )
            .padding(horizontal = 10.dp, vertical = 4.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Text(
            text = tag,
            style = MaterialTheme.typography.labelSmall,
            color = contentColor,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.widthIn(max = 96.dp),
        )
    }
}

@Composable
private fun HiddenTagCountChip(
    count: Int,
    modifier: Modifier = Modifier,
) {
    val shape = if (isIosPlatform) RoundedCornerShape(percent = 50) else RoundedCornerShape(14.dp)

    Box(
        modifier = modifier
            .clip(shape)
            .background(MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.35f))
            .border(BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant), shape)
            .padding(horizontal = 10.dp, vertical = 4.dp),
    ) {
        Text(
            text = "+$count",
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

private fun prioritizedCardTags(tags: List<String>, selectedTags: Set<String>): List<String> =
    buildList {
        addAll(tags.filter { it in selectedTags })
        addAll(tags.filterNot { it in selectedTags })
    }.distinct()

private fun visibleHomeFilterTags(
    allTags: List<String>,
    selectedTags: Set<String>,
    showAllTags: Boolean,
): List<String> {
    if (showAllTags || allTags.size <= MAX_COLLAPSED_HOME_FILTER_TAGS) return allTags
    val prioritizedTags = prioritizedCardTags(allTags, selectedTags)
    val selectedVisible = prioritizedTags.filter { it in selectedTags }
    val remainingSlots = (MAX_COLLAPSED_HOME_FILTER_TAGS - selectedVisible.size).coerceAtLeast(0)
    val otherVisible = prioritizedTags.filterNot { it in selectedTags }.take(remainingSlots)
    return (selectedVisible + otherVisible).distinct()
}

private const val MAX_VISIBLE_CARD_TAGS = 2
private const val MAX_COLLAPSED_HOME_FILTER_TAGS = 4

private fun buildResultsSummary(
    totalCount: Int,
    visibleCount: Int,
    sortMode: HomeSortMode,
    hasActiveFilters: Boolean,
): String {
    val countLabel = if (hasActiveFilters) {
        "$visibleCount of $totalCount places"
    } else {
        "$totalCount places"
    }
    val sortLabel = when (sortMode) {
        HomeSortMode.DEFAULT -> null
        HomeSortMode.MOST_RECENT -> "recent first"
        HomeSortMode.NEAREST -> "nearest first"
        HomeSortMode.NAME -> "A to Z"
    }
    return sortLabel?.let { "$countLabel · $it" } ?: countLabel
}

private fun defaultBackupFileName(): String {
    val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    fun p(n: Int) = n.toString().padStart(2, '0')
    val ts = "${now.year}${p(now.monthNumber)}${p(now.dayOfMonth)}-${p(now.hour)}${p(now.minute)}${p(now.second)}"
    return "hotpl-backup-$ts.json"
}
